<template>
  <div
    class="wrap"
    :class="[{ 'light-bg' : current.style === 'dark' }, { 'exit-transitions' : exitNow }]"
  >

    <section class="featured fixed-block grid59">
      <img
        v-for="tile of tiles" 
        :key="tile.id"
        :src="tile.large_image" :alt="tile.title"
        :class="{ 'active' : tile.id === current.id }"
      >

      <ul>
        <li
          v-for="tile of tiles"
          :key="tile.id"
          :class="{ 'active' : tile.id === current.id }"
        >
          <a @click="changeTile(tile)">{{ tile.menu_title }}</a>
        </li>
      </ul>

    </section>
    <section class="sidebar grid41">

      <article class="block" id="top">
        <h2>{{ homepage_data.lead_copy }}</h2>
        <a @click="changeTile(tiles[0])">
          <img src="/images/arrow-down.svg" alt="St Lukes Church: scroll">
        </a>
      </article>

      <article
        v-for="tile of tiles"
        :key="tile.id"
        :id="tile.id"
        class="block"
        :class="{ 'grey' : tile.title === 'Watch' }"
        v-view="viewHandler"
      >
          <h3 class="small-title">{{ tile.title }}</h3>
          <h4>{{ tile.sub_title }}</h4>

          <img :src="tile.image" :alt="tile.title">
          <a @click="goTo(tile)" class="button">Read more</a>
      </article>

    </section>

  </div>
</template>

<script>
export default {
  props: {
    tiles: Array,
    homepage_data: Array
  },

  data () {
    return {
      current: {},
      exitNow: false
    };
  },

  computed: {
    browserWidth () {
      return Math.max(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
      );
    }
  }, 

  mounted () {
    this.current = this.tiles[0]
  },

  methods: {
    
    changeTile (tile) {
      if (this.browserWidth > 767) {
        this.scrollTop(tile.id)
      } else {
        this.goTo(tile)
      }
    },

    scrollTop (id) {
        document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    },

    viewHandler (e) {
      if (e.type === 'progress' && e.percentTop < 0.5) {
        // console.log(e)
        let id = parseInt(e.target.element.id)
        let tile = this.tiles.find(obj => obj.id === id)
        this.current = tile
        this.$parent.style = this.current.style
      }
    },

    goTo (tile) {
      this.exitNow = true
      setTimeout(() => {
        window.location = tile.url
      }, 1000)
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Home.vue